import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  subtext?: string;
  href?: string;
  className?: string;
}
export function CTAButton({
  text,
  subtext,
  href,
  className = ''
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (!href) {
      e.preventDefault();
      document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const ButtonContent = <div className={`relative w-full max-w-md mx-auto group cta-pulse ${className}`} data-id="element-42">
      <button onClick={handleClick} className="relative w-full flex flex-col items-center justify-center px-4 py-2.5 md:px-5 md:py-3 bg-red-600 rounded-lg shadow-md text-white font-bold text-sm md:text-lg hover:bg-red-700 transition-colors cursor-pointer" data-id="element-43">
        <div className="flex items-center gap-2 text-center" data-id="element-44">
          {text}
          <ArrowRightIcon className="w-4 h-4" data-id="element-45" />
        </div>
        {subtext && <span className="text-xs md:text-sm font-medium text-red-100 mt-1" data-id="element-46">
            {subtext}
          </span>}
      </button>
    </div>;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-47">
        {ButtonContent}
      </a>;
  }
  return ButtonContent;
}